import { ActionTypes } from '../constants';
import { ChangedCatalogSearchAction } from '../types';

export default function changedCatalogSearch(searchText: string): ChangedCatalogSearchAction {
  return { type: ActionTypes.CHANGED_CATALOG_SEARCH, payload: searchText };
}
